<template>
  <div class="box">
    <div class="box_center">
      <div class="leftdiv">今日: {{ data }}  {{ nowWeek }} </div>
      <div class="rightdiv">
        <a href="#">设置首页</a>
        <span class="spilt">|</span>
        <a href="#">加入收藏</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: '',
      nowWeek: '星期'
    }
  },
  mounted() {
    const date = new Date()
     const year = date.getFullYear()
      const month = date.getMonth() + 1
      const strDate = date.getDate()
      this.data = year + '年' + month + '月' + strDate + '日'
    const week = '星期' + '日一二三四五六'.charAt(date.getDay())
    this.nowWeek = week
  }
}
</script>
<style>
/**盒子布局 */
.box {
  /* position:absolute; */
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #314f47;
  opacity: 0.7;
  z-index: 1;
  min-width: 1200px;
}
.box_center {
  width: 80%;
  margin: 0 auto;
  min-width: 1200px;
}
/**左右浮动布局 */
.leftdiv {
  float: left;
  color: #ffffff;
  font-size: 15px;
}
.rightdiv {
  float: right;
  color: #ffffff;
  font-size: 15px;
  margin-right: 10px;
}
/**a标签的布局 */
a {
  text-decoration: none;
  color: #ffffff;
}
/**|的样式 */
.spilt {
  color: #ffffff;
  display: inline-block;
  width: 45px;
  text-align: center;
}
</style>
